import type { EnterprisePillar } from '../config/brand';

interface PillarIconProps {
  icon: EnterprisePillar['icon'];
  className?: string;
}

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/** Resolves an enterprise-pillar icon key to a consistent line icon. */
export default function PillarIcon({ icon, className }: PillarIconProps) {
  switch (icon) {
    case 'purity':
      // Droplet + orbit — molecular purity
      return (
        <svg {...base} className={className}>
          <path d="M12 2.7C15 6.4 18 9.6 18 13a6 6 0 0 1-12 0c0-3.4 3-6.6 6-10.3Z" />
          <circle cx="12" cy="13.5" r="2" />
        </svg>
      );
    case 'flagship':
      // Faceted gem — crowning flagship
      return (
        <svg {...base} className={className}>
          <path d="M6 3h12l3 6-9 12L3 9l3-6Z" />
          <path d="M3 9h18M9 3 7.5 9 12 21l4.5-12L15 3M9 9h6" />
        </svg>
      );
    case 'concierge':
      // Beaker + gear — precision lab
      return (
        <svg {...base} className={className}>
          <path d="M9 3h6M10 3v5.5L5.6 18a1.6 1.6 0 0 0 1.45 2.3h9.9A1.6 1.6 0 0 0 18.4 18L14 8.5V3" />
          <path d="M7.6 14h8.8" />
          <circle cx="12" cy="16.5" r="1.1" />
        </svg>
      );
    case 'shield':
    default:
      // Shield + check — operational assurance
      return (
        <svg {...base} className={className}>
          <path d="M12 3 5 6v5c0 4.4 3 7.6 7 8.9 4-1.3 7-4.5 7-8.9V6l-7-3Z" />
          <path d="m9 11.5 2 2 4-4" />
        </svg>
      );
  }
}
